import React from 'react'

const Subscribers = () => {
  return <h2>Subscribers!</h2>
}

export default Subscribers
